import React from "react";
import _ from "lodash";
import sizeMe from "react-sizeme";
import ReactDOM from "react-dom";
// import { renderToString } from "react-dom/server";

import {
  LadChicletSVG as ChicletSVG,
  BoxChicletSVG
} from "../../components/chiclets";
import { getCenter, getBoundingBox , isFenceValid} from "../geofence-edit/geofence-types";
import { geofenceShapesForLocation } from "../geofence-edit/geofence-map-shapes";
import { LocInfoWindow } from "./LocInfoWindow";

class MapView extends React.Component {
  constructor(props) {
    super(props);

    this.map = null;
    this.mapDiv = null;
    this.mapObjects = {};
    this.geofenceShapes = [];

    this.debouncedResizeMap = _.debounce(this.resizeMap, 100);
    this.markerClickHandler = this.markerClickHandler.bind(this);
    this.debouncedDrawGeofence = _.debounce(this.drawGeofence, 100);
  }

  state = {
    mapLocations: []
  };

  componentDidMount() {
    this.initMap();
    this.addLocations();
  }

  geofenceChanged(prevProps) {
    const currentGeofence = _.get(this.props, "selectedLocation.geofence");
    const prevGeofence = _.get(prevProps, "selectedLocation.geofence");
    const didChange = !_.isEqual(currentGeofence, prevGeofence);
    return didChange;
  }

  addLocations() {
    const { mapLocations, selectedLad } = this.props;

    if (mapLocations && mapLocations !== this.state.mapLocations) {
      this.updateLocations(mapLocations, selectedLad);
      this.setState({ mapLocations });
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedLocation, isDrawingGeofence } = this.props;
    const { width, height } = this.props.size;

    if (this.geofenceChanged(prevProps)) {
      this.clearMap();
    }

    this.clearInfoBubbles();
    this.addLocations();

    if (selectedLocation) {
      this.zoomSingleLocation(selectedLocation);
      if (isDrawingGeofence) {
        this.debouncedDrawGeofence(selectedLocation);
      }
    }

    if (width !== prevProps.width || height !== prevProps.height) {
      this.debouncedResizeMap();
    }
  }

  drawGeofence(location) {
    if (!isFenceValid(location.geofence)) {
      return;
    }
    this.geofenceShapes.forEach(s => this.map.removeObject(s));
    const { H } = this.props;
    const shapes = geofenceShapesForLocation(location, H);
    this.geofenceShapes = shapes;
    shapes.forEach(s => {
      this.map.addObject(s);
    });
  }

  checkLocationGeofence(pos) {
    const hasGeofence = !_.isNil(pos.latitude) && !_.isNil(pos.longitude);
    return hasGeofence;
  }

  updateLocations(locations, selectedLad) {
    this.clearMap();

    let sumLat = 0;
    let sumLong = 0;
    let markerCount = 0;

    if (locations && selectedLad && !_.isEmpty(locations)) {
      locations.forEach((location, i) => {
        // Client asked not to map locations that don't have a geofence (i.e. 0 lat/0 long) per DEV-272
        if (
          !_.isEmpty(location.geofence.properties.center) &&
          this.checkLocationGeofence(location.geofence.properties.center)
        ) {
          const pos = {
            lat: location.geofence.properties.center.latitude,
            lng: location.geofence.properties.center.longitude
          };

          sumLat += pos.lat;
          sumLong += pos.lng;
          markerCount += 1;
          this.addMarker(location.id, selectedLad, pos, location);
        }
      });

      if (markerCount > 0) {
        this.map.setCenter({
          lat: sumLat / markerCount,
          lng: sumLong / markerCount
        });
      }
      this.map.setZoom(5);
    }
  }

  zoomSingleLocation(location) {
    const { H } = this.props;
    const { geofence } = location;
    if (isFenceValid(geofence)) {
      const bounds = getBoundingBox(geofence);
      this.map.setViewBounds(new H.geo.Rect(...bounds));
      const centerPos = getCenter(geofence);
      this.map.setCenter(centerPos);
      this.map.setZoom(14);
    }
  }

  initMap() {
    const { H, platform } = this.props;

    let defaultLayers = platform.createDefaultLayers();

    this.map = new H.Map(this.mapDiv, defaultLayers.normal.map, {
      zoom: 5,
      center: { lat: 41.8625, lng: -87.6166 }
      // pixelRatio: Math.min(2, devicePixelRatio)
    });

    this.behavior = new H.mapevents.Behavior(
      new H.mapevents.MapEvents(this.map)
    );

    this.ui = H.ui.UI.createDefault(this.map, defaultLayers);
    this.ui.getControl("zoom").setAlignment("right-bottom");
    this.ui.setUnitSystem(H.ui.UnitSystem.IMPERIAL);
  }

  clearMap() {
    if (!_.isNil(this.mapObjects) && !_.isEmpty(this.mapObjects)) {
      _.forOwn(this.mapObjects, (val, key) => {
        this.map.removeObject(val);
      });

      this.mapObjects = {};
    }

    this.mapObjects = {};
  }

  addMarker(id, lad, position, location = {}, height = 45, width = 45) {
    const { markerIsClickable, H, useBoxChiclets } = this.props;
    let svg = ChicletSVG({
      lad: lad,
      chicletStyle: useBoxChiclets ? BoxChicletSVG : ChicletSVG
    });

    const icon = new H.map.Icon(svg, { size: { h: height, w: width } });
    const marker = new H.map.Marker(position);
    marker.setIcon(icon);

    marker.setData({
      id: id,
      pos: position,
      location: location,
      lad: lad
    });

    if (markerIsClickable)
      marker.addEventListener("tap", this.markerClickHandler);

    this.map.addObject(marker);
    this.mapObjects[id] = marker;
  }

  markerClickHandler(e) {
    const { H, mapLocations } = this.props;
    const marker = e.target;

    if (mapLocations) {
      this.clearInfoBubbles();
      const markerdata = marker.getData();

      // if (marker instanceof H.map.Marker) marker.setZindex(10);

      let bubble = new H.ui.InfoBubble(markerdata.pos, {
        content: this.getInfoBubble(markerdata.location, markerdata.lad)
      });

      this.ui.addBubble(bubble);
      this.map.setCenter(markerdata.pos);
      this.map.setZoom(8);
    }
  }

  clearInfoBubbles() {
    let bubbles = this.ui.getBubbles();

    if (!_.isEmpty(bubbles))
      bubbles.forEach(b => {
        this.ui.removeBubble(b);
      });
  }

  getInfoBubble(data, lad) {
    const { eventHandler } = this.props;

    // FIXME: HERE maps requires a string or HTML node. Converting Component to a Node, but feels hacky.
    var tempdiv = document.createElement("div");
    ReactDOM.render(
      <LocInfoWindow data={data} lad={lad} eventHandler={eventHandler} />,
      tempdiv
    );

    return tempdiv;
  }

  resizeMap() {
    if (this.map) {
      this.map.getViewPort().resize();
    }
  }

  render() {
    return (
      <div
        id="routes-map"
        style={{ height: "100%", width: "100%" }}
        ref={el => (this.mapDiv = el)}
      />
    );
  }
}

export default sizeMe({ monitorHeight: true })(MapView);



// WEBPACK FOOTER //
// ./src/modules/map/MapView.js